import { useState } from "react";

import { Roles } from "src/core/constants/roles";
import { useFolder } from "src/core/contexts/FolderContext";
import { useFolderGraphSync } from "src/core/contexts/FolderGraphSyncContext";
import { useExecuteWorkflowActionMutation } from "src/core/gql/graphql";
import { usePermissions } from "src/core/hooks/usePermissions";
import { buildFolderFilesCountRefetch } from "src/core/utils/refetchers";

export const useSendToValidation = (setShowConfirmDialog: (show: boolean) => void) => {
  const { folderFile, refetch } = useFolder();

  const [executeWorkflowAction] = useExecuteWorkflowActionMutation();
  const [isLoading, setIsLoading] = useState(false);

  const { hasRole } = usePermissions();
  const { setSelectedTab } = useFolderGraphSync();

  const validate = async (): Promise<{
    status: "success" | "error";
    folderFileId?: string;
    redirect?: boolean;
  }> => {
    const folderFileId = folderFile.folderFile?.id;

    if (!folderFileId) {
      throw new Error("Folder file ID is required");
    }

    try {
      setIsLoading(true);
      await executeWorkflowAction({
        variables: {
          actionId: "SUBMIT",
          folderFileId: folderFileId,
        },
        awaitRefetchQueries: true,
        refetchQueries: buildFolderFilesCountRefetch(),
      });

      await refetch();

      setShowConfirmDialog(false);
      setSelectedTab("cartographie");

      return {
        status: "success",
        folderFileId,
        redirect: hasRole(Roles.COLLABORATEUR),
      };
    } catch (error) {
      console.error("[useSendToValidation::validate] Error: ", error);
      return {
        status: "error",
      };
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setShowConfirmDialog(false);
  };

  return { validate, handleCancel, isLoading };
};
